import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getSupplierForecastSaveDataSlice = createApi(`SupplierForecastSaveDataSlice`,"POST");

const SupplierForecastSaveDataSlice = createSlice({
  name: 'SupplierForecastSaveDataSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSupplierForecastSaveDataSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSupplierForecastSaveDataSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getSupplierForecastSaveDataSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default SupplierForecastSaveDataSlice.reducer;